'use client';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { DATA_KEYS } from '@/consts/dataKeys';

export const InitialBoxDescription = () => {
  const { flags } = useDataProvider(DATA_KEYS.productSelection);

  return flags.priceSummaryHeaderText || '30-day trial box';
};
